const RANK_MAP: Record<string, string> = {
  Iron: "Iron",
  Bronze: "Bronze",
  Silver: "Silver",
  Gold: "Gold",
  Platinum: "Platinum",
  Emerald: "Emerald",
  Diamond: "Diamond",
  Grandmaster: "Grandmaster",
  Master: "Master",
  Challenger: "Challenger",
};

const RANK_KEYS_SORTED = Object.keys(RANK_MAP).sort(
  (a, b) => b.length - a.length,
);

export function getRiotRankImageUrl(
  rank: string | null | undefined,
): string | null {
  if (!rank || !rank.trim()) return null;
  const key = RANK_KEYS_SORTED.find((k) =>
    rank.toLowerCase().includes(k.toLowerCase()),
  );
  // WebP 128×128 (≈2–8 КБ). Раньше лежал 512×512 (≈30–56 КБ) при максимальном
  // отображении ≤48px (riot-accounts-section, retina 2x = 96px) — 512px не нужен
  // нигде в приложении, самый мелкий вариант везде ≤24px. До 512×512 был исходный
  // 1000px PNG (184–714 КБ).
  return key ? `/ranks/Rank=${RANK_MAP[key]}.webp` : null;
}
